"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var includes_1 = __importDefault(require("lodash/includes"));
var isArray_1 = __importDefault(require("lodash/isArray"));
function check(fn, error) {
    return function (value) {
        if (fn(value)) {
            return { pass: true };
        }
        else {
            return { pass: false, error: error };
        }
    };
}
check.isOneOf = function isOneOf(options) {
    return includes_1.default.bind(this, options);
};
check.isArrayOf = function (itemValidator) {
    return function (value) {
        return isArray_1.default(value) && value.every(itemValidator);
    };
};
module.exports = check;
//# sourceMappingURL=typecheck.js.map